import { Skeleton } from "@mui/material";

export const LoadingSkeletons = () => (
    Array.from({ length: 8 }).map((_, i) => (
        <Skeleton key={i} height={150} width={'100%'} animation="wave" />
    ))
);